import React, { useEffect, useState, useRef } from "react";
import {
  dynamicOfferFilter,
  offerActivation,
  updateRepostOffer,
  repostOffer,
  getCategories,
  getAllProductsByCategory,
  getPropertiesByProduct,
  getPropertyValues,
  getProductById,
  updateOffer,
} from "../../services/productServices";

import { fetchAllInteraction } from "../../services/InteractionAndOffer";


function ListOffer() {
  const [offers, setOffers] = useState([]);
  const [filters, setFilters] = useState({
    productName: "",
    status: "",
    category: "",
    page: 1,
    latest: true,
  });
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedEditOffer, setSelectedEditOffer] = useState(null);
  const [selectedViewOffer, setSelectedViewOffer] = useState(null);
  const [selectedRepostOffer, setSelectedRepostOffer] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState({});
  const [toast, setToast] = useState({ message: "", isError: false });
  
  const [reposting, setReposting] = useState(false);

  const [selectedBulkOffers, setSelectedBulkOffers] = useState([]);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [bulkProgress, setBulkProgress] = useState(0);
  const [bulkTotal, setBulkTotal] = useState(0);
  const [showBulkConfirm, setShowBulkConfirm] = useState(false);


  const [interactionMap, setInteractionMap] = useState({});

  const categoryMapping = {
    CoffeeAndMainCommodities: "Coffee / ቡና",
    FruitCrops: "Fruit Crops / ፍራፍሬች",
    BuildingMaterials: "Building Materials / የግንባታ እቃዎች",
    GrainsAndCereals: "Grains and Cereals / የእህል ሰብሎች",
    PulsesLegumes: "Pulses & Legumes / ጥራጥሬዎች ",
    OilSeeds: "Oil Seeds / የቅባት እህሎች",
    RootCrops: "Root Crops / የስራስር ሰብሎች",
    Vegetables: "Vegetables  / አትክልቶች",
    SpicesHerbs: "Spice & Herbs / ቅመማ ቅመሞቾ",
  };

  const handleToggleStatus = async (offer) => {
    const currentStatus = !!Number(offer.status); // Normalize to boolean
    const newStatus = currentStatus ? 0 : 1;

    const rawCategory = offer.category || filters.category;

    if (!rawCategory) {
      setToast({
        message: "Unable to determine category key for this offer.",
        isError: true,
      });
      return;
    }

    const categoryKey = categoryMapping[rawCategory.trim()] || rawCategory;

    try {
      setLoadingStatus((prev) => ({ ...prev, [offer.id]: true })); // Start loading

      const result = await offerActivation(offer.id, newStatus, categoryKey);

      if (result.error) {
        setToast({ message: `Error: ${result.message}`, isError: true });
      } else {
        setToast({ message: result.message, isError: false });
        loadOffers(); // Refresh the list
      }
    } catch (error) {
      console.error("Error toggling status:", error);
      setToast({
        message: "An error occurred while toggling status.",
        isError: true,
      });
    } finally {
      setLoadingStatus((prev) => ({ ...prev, [offer.id]: false })); // Stop loading
    }
  };

  useEffect(() => {
  const handleEsc = (e) => {
    if (e.key === "Escape") {
      setSelectedViewOffer(null);
      setSelectedRepostOffer(null);
      setShowBulkConfirm(false);
      setSelectedEditOffer(null);
    }
  };

  window.addEventListener("keydown", handleEsc);

  return () => window.removeEventListener("keydown", handleEsc);
}, []);



  const handleView = (offer) => {
    setSelectedViewOffer(offer);
  };

  const handleRepost = (offer) => {
    setSelectedRepostOffer(offer);
  }

  const repostOfferTG = async (offer) => {
    setReposting(true);
    const res = await repostOffer(offer.category, offer.id).then((data) => {
      setToast({ message: `Offer ID: ${offer.id} reposted successfully!`, isError: false });
      setSelectedRepostOffer(null);
      setReposting(false);
      loadOffers();
    }).catch((error) => {
      setReposting(false);
      setToast({ message: "Error reposting offer.", isError: true });
    });

    await updateRepostOffer(offer.category, offer.id);  
    

  };

  const handleEdit = (offer) => {
    setSelectedEditOffer(offer);
  }

  const loadOffers = async () => {
    setLoading(true);
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "")
    );

    const result = await dynamicOfferFilter(cleanedFilters);

    if (result?.offers) {
      setOffers(
      result.offers.map((offer) => ({
      ...offer,
    uniqueKey: `${offer.product_name}-${offer.id}`,
  }))
);

      setPagination(result.pagination);
    } else {
      setOffers([]);
      setPagination(null);
    }

    setLoading(false);
  };

  useEffect(() => {
  const loadInteractions = async () => {
    try {
      const interactions = await fetchAllInteraction();

      const countMap = interactions.reduce((acc, interaction) => {
        if (
          interaction.offer &&
          interaction.offer.product_name &&
          interaction.offer.id
        ) {
          const key = `${interaction.offer.product_name}-${interaction.offer.id}`;
          acc[key] = (acc[key] || 0) + 1;
        }
        return acc;
      }, {});

      setInteractionMap(countMap);
    } catch (err) {
      console.error("Error loading interactions:", err);
    }
  };

  loadInteractions();
}, []);

const handleBulkRepost = async () => {
  setBulkLoading(true);
  setBulkProgress(0);
  setBulkTotal(selectedBulkOffers.length);

  try {
    // Map selected offer IDs to their full offer objects and sort by createdAt (earliest first)
    const sortedOffers = selectedBulkOffers
      .map(offerId => offers.find(o => o.id === offerId))
      .filter(offer => offer !== undefined)
      .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());

    for (let i = 0; i < sortedOffers.length; i++) {
      const offer = sortedOffers[i];

      await repostOffer(offer.category, offer.id);
      await updateRepostOffer(offer.category, offer.id);

      // update progress bar
      setBulkProgress(i + 1);
    }

    setToast({ message: "Bulk repost completed!", isError: false });
    loadOffers();
    setSelectedBulkOffers([]);
  } catch (err) {
    console.error(err);
    setToast({ message: "Error during bulk repost", isError: true });
  }

  setBulkLoading(false);
};



  useEffect(() => {
    loadOffers();
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      page: 1,
    }));
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4 text-center">Filtered Offers</h2>

      {/* Filter Form */}
      <div className="flex gap-4 mb-4 flex-wrap justify-center">
        <input
          type="text"
          name="productName"
          value={filters.productName}
          onChange={handleFilterChange}
          placeholder="Product Name"
          className="border p-2 rounded"
        />

        <select
          name="status"
          value={filters.status}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        >
          <option value="">All Status</option>
          <option value="1">On</option>
          <option value="0">Off</option>
        </select>

        <select
          name="category"
          value={filters.category}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        >
          <option value="">All Categories</option>
          <option value="CoffeeAndMainCommodities">Coffee / ቡና</option>
          <option value="SpicesHerbs">Spice & Herbs / ቅመማ ቅመሞቾ</option>
          <option value="GrainsAndCereals">
            Grains and Cereals / የእህል ሰብሎች
          </option>
          <option value="FruitCrops">Fruit Crops / ፍራፍሬች</option>
          <option value="BuildingMaterials">
            Building Materials / የግንባታ እቃዎች
          </option>
          <option value="PulsesLegumes">Pulses & Legumes / ጥራጥሬዎች</option>
          <option value="OilSeeds">Oil Seeds / የቅባት እህሎች</option>
          <option value="RootCrops">Root Crops / የስራስር ሰብሎች</option>
          <option value="Vegetables">Vegetables / አትክልቶች</option>

          {/* Add more categories if needed */}
        </select>
      </div>

      {/* Offers List and Details */}
      <div className="flex flex-col gap-4 items-center">
        {/* Bulk Repost Button */}
          {
            (selectedBulkOffers.length > 0 &&
              (
                <div className="flex justify-start mb-3">
            <button
              disabled={selectedBulkOffers.length === 0 || bulkLoading}
              className={`px-4 py-2 rounded text-white ${
                selectedBulkOffers.length === 0 || bulkLoading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
              onClick={() => setShowBulkConfirm(true)}
            >
              {bulkLoading
                ? "Reposting..."
                : `Bulk Repost (${selectedBulkOffers.length})`}
            </button>
          </div>
              )
            )
          }

          {/* Progress Bar (only shown while bulk repost is running) */}
          {bulkLoading && (
            <div className="flex flex-col items-center mb-4">
              {/* Circular spinner with text inside */}
              <div className="relative">
                {/* Spinner ring */}
                <div className="w-16 h-16 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>

                {/* Progress text */}
                <div className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-gray-700">
                  {bulkProgress}/{bulkTotal}
                </div>
              </div>

              <div className="mt-2 text-gray-600 text-sm">
                Reposting...
              </div>
            </div>
          )}


          {bulkLoading && (
            <div className="text-sm text-gray-700 mb-4">
              Reposting {bulkProgress}/{bulkTotal} offers...
            </div>
          )}

        {/* Table Section */}
        <div className="w-4/5 overflow-x-auto">
          {loading ? (
            <div className="flex justify-center py-6">
              <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
            </div>
          ) : offers.length === 0 ? (
            <div className="flex justify-center"><span>No Offers Found.</span></div>
          ) : (
              
            <table className="table-auto border-collapse border border-gray-300 w-full bg-white">
              <thead>
                <tr>
                  <th className="border border-gray-300 px-4 py-2">
                    <input
                      type="checkbox"
                      checked={selectedBulkOffers.length === offers.length && offers.length > 0}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedBulkOffers(offers.map(o => o.id));
                        } else {
                          setSelectedBulkOffers([]);
                        }
                      }}
                    />
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-center">ID</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Image</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Product</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Status</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Poster</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Views</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Post_Count</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Date</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {offers.map((offer, index) => {
                  const isActive = !!Number(offer.status);

                  return (
                    
                    <tr key={index}>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        <input
                          type="checkbox"
                          checked={selectedBulkOffers.includes(offer.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedBulkOffers(prev => [...prev, offer.id]);
                            } else {
                              setSelectedBulkOffers(prev => prev.filter(id => id !== offer.id));
                            }
                          }}
                        />
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {offer.id}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        <img
                          src={offer.picture_link || offer.product?.picture_link || ""}
                          alt={offer.product_name || "No Image"}
                          className="w-16 h-16 object-cover"
                        />
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {offer.product_name || "N/A"}
                        {offer.post_count > 1 ? (
                          <span title="Reposted" className="text-blue-600 text-xl cursor-pointer">🔁</span>
                          ) : (
                          <span className="text-gray-400 text-xl"></span>
                        )}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {isActive ? "Active" : "Inactive"}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {offer.poster}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {interactionMap[offer.uniqueKey] || 1}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {offer.post_count}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {new Date(offer.createdAt).toLocaleString()}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        <div className="flex flex-col gap-2 flex-wrap">
                          <div className="flex gap-1">
                            <button
                            className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300"
                            onClick={() => handleView(offer)}
                          >
                            View
                          </button>
                          <button
                            className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300"
                            onClick={() => handleRepost(offer)}
                          >
                            Repost
                          </button>
                          <button
                            className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300"
                            onClick={() => handleEdit(offer)}
                          >
                            Edit
                          </button>
                          </div>
                          <button
                            className={`px-3 py-1 rounded ${
                              isActive
                                ? "bg-red-500 text-white hover:bg-red-600 w-full"
                                : "bg-green-500 text-white hover:bg-green-600 w-full"
                            } ${
                              loadingStatus[offer.id]
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                            onClick={() => handleToggleStatus(offer)}
                            disabled={loadingStatus[offer.id]} // Disable the button while loading
                          >
                            {loadingStatus[offer.id]
                              ? "Processing..." // Show loading text
                              : isActive
                              ? "Deactivate"
                              : "Activate"}
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>  

        {/* Details Section */}
        {/* <div className="w-1/2 border border-gray-300 p-4 bg-white sticky top-4 h-fit self-start">
          {selectedOffer ? (
            <div>
              <h3 className="text-lg font-bold mb-2">Offer Details</h3>
              <p>
                <strong>Product Name:</strong> {selectedOffer.product_name}
              </p>
              <p>
                <strong>Category:</strong> {selectedOffer.category}
              </p>
              <p>
                <strong>Region:</strong> {selectedOffer.region}
              </p>
              <p>
                <strong>Quantity:</strong> {selectedOffer.quantity}
              </p>
              <p>
                <strong>Price:</strong> {selectedOffer.price || "N/A"}
              </p>
              <p>
                <strong>Grade:</strong> {selectedOffer.grade}
              </p>
              <p>
                <strong>Process:</strong> {selectedOffer.process}
              </p>
              <p>
                <strong>Transaction:</strong> {selectedOffer.transaction}
              </p>
              <p>
                <strong>Description:</strong> {selectedOffer.description}
              </p>
              <p>
                <strong>Poster:</strong> {selectedOffer.poster}
              </p>
              <p>
                <strong>Date:</strong>{" "}
                {new Date(selectedOffer.createdAt).toLocaleString()}
              </p>
            </div>
          ) : (
            <div>Select an offer to view details.</div>
          )}
        </div> */}
      </div>

      {/* Pagination */}
      {pagination && !(offers.length === 0) && (
        <div className="mt-4 overflow-x-auto flex justify-center">
          <div className="flex gap-2 w-max">
            {/* Always show current page */}
            {
              pagination.currentPage > 2 &&(
                <button
              onClick={() => handlePageChange(pagination.currentPage - 2)}
              className="px-3 py-1 border rounded"
            >
              {pagination.currentPage - 2}
            </button>
              )
            }
            {
              pagination.currentPage > 1 &&(
                <button
              onClick={() => handlePageChange(pagination.currentPage - 1)}
              className="px-3 py-1 border rounded"
            >
              {pagination.currentPage - 1}
            </button>
              )
            }
            <button
              onClick={() => handlePageChange(pagination.currentPage)}
              className={`px-3 py-1 border rounded ${
                true ? "bg-blue-500 text-white" : ""
              }`}
            >
              {pagination.currentPage}
            </button>

            {/* Show next two pages if exist */}
            {pagination.currentPage + 1 <= pagination.totalPages && (
              <button
                onClick={() => handlePageChange(pagination.currentPage + 1)}
                className="px-3 py-1 border rounded"
              >
                {pagination.currentPage + 1}
              </button>
            )}

            {pagination.currentPage + 2 <= pagination.totalPages && (
              <button
                onClick={() => handlePageChange(pagination.currentPage + 2)}
                className="px-3 py-1 border rounded"
              >
                {pagination.currentPage + 2}
              </button>
            )}

            {/* Ellipsis if there's a gap */}
            {pagination.currentPage + 3 < pagination.totalPages && (
              <span className="px-3 py-1">...</span>
            )}

            {/* Always show last page if it's not already visible */}
            {pagination.totalPages > pagination.currentPage + 2 && (
              <button
                onClick={() => handlePageChange(pagination.totalPages)}
                className={`px-3 py-1 border rounded ${
                  pagination.currentPage === pagination.totalPages
                    ? "bg-blue-500 text-white"
                    : ""
                }`}
              >
                {pagination.totalPages}
              </button>
            )}
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {toast.message && (
        <div
          className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded shadow z-50 ${
            toast.isError
              ? "bg-red-100 text-red-700"
              : "bg-green-100 text-green-700"
          }`}
        >
          {toast.message}
          <button
            onClick={() => setToast({ message: "", isError: false })}
            className="ml-4 font-bold"
          >
            ×
          </button>
        </div>
      )}
      {
        selectedRepostOffer && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedRepostOffer(null)}
        >
          <div 
            className="bg-white rounded shadow-lg w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Sticky Header */}
            <div className="sticky top-0 bg-white px-4 sm:px-6 pt-4 sm:pt-6 pb-2 border-b z-10">
              <h3 className="text-base sm:text-lg font-bold">Repost Offer</h3>
            </div>

            {/* Scrollable Content */}
            <div className="px-4 sm:px-6 py-4 overflow-y-auto flex-1">
              {/* FLEX WRAPPER */}
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">

                {/* LEFT COLUMN - DETAILS */}
                <div className="flex-1 space-y-1 sm:space-y-2 text-sm sm:text-base">
                  <p className="text-gray-600">
                    Offer Id: <span className="font-bold text-black">{selectedRepostOffer.id}</span>
                  </p>

                  <p className="text-gray-600">
                    Product Name: <span className="font-bold text-black">{selectedRepostOffer.product_name}</span>
                  </p>

                  <p className="text-gray-600">
                    Category: <span className="font-bold text-black">{selectedRepostOffer.category}</span>
                  </p>

                  <p className="text-gray-600">
                    Region: <span className="font-bold text-black">{selectedRepostOffer.region}</span>
                  </p>

                  <p className="text-gray-600">
                    Quantity: <span className="font-bold text-black">{selectedRepostOffer.quantity}</span>
                  </p>

                  <p className="text-gray-600">
                    Price: <span className="font-bold text-black">{selectedRepostOffer.price ?? "N/A"}</span>
                  </p>

                  <p className="text-gray-600">
                    Grade: <span className="font-bold text-black">{selectedRepostOffer.grade}</span>
                  </p>

                  <p className="text-gray-600">
                    Process: <span className="font-bold text-black">{selectedRepostOffer.process}</span>
                  </p>

                  <p className="text-gray-600">
                    Transaction: <span className="font-bold text-black">{selectedRepostOffer.transaction}</span>
                  </p>

                  <p className="text-gray-600">
                    Description:{" "}
                    <span className="font-bold text-black">
                      {selectedRepostOffer.description || "No Description"}
                    </span>
                  </p>

                  <p className="text-gray-600">
                    Poster: <span className="font-bold text-black">{selectedRepostOffer.user_name}</span>
                  </p>

                  <p className="text-gray-600">
                    Date:{" "}
                    <span className="font-bold text-black">
                      {new Date(selectedRepostOffer.createdAt).toLocaleDateString()}
                    </span>
                  </p>
                </div>

                {/* RIGHT COLUMN - IMAGE */}
                {selectedRepostOffer.image_filelink && !(selectedRepostOffer.image_filelink === "") && (
                  <div className="flex-1 flex items-center justify-center">
                    <img
                      src={selectedRepostOffer.image_filelink}
                      alt={selectedRepostOffer.product_name || "Product Image"}
                      className="max-w-full max-h-40 sm:max-h-64 object-cover rounded"  
                    />
                  </div>
                ) }

              </div>
            </div>

            {/* Sticky Footer Buttons */}
            <div className="sticky bottom-0 bg-white border-t px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row justify-end gap-2 sm:gap-4">
              <button 
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 text-sm sm:text-base order-1"
                onClick={() => repostOfferTG(selectedRepostOffer)}
              >
                {reposting ? "Reposting..." : "Repost Offer"}
              </button>
              <button
                onClick={() => setSelectedRepostOffer(null)}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 text-sm sm:text-base order-2"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
      }
      {
        selectedViewOffer && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedViewOffer(null)}
        >
          <div 
            className="bg-white rounded shadow-lg w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Sticky Header */}
            <div className="sticky top-0 bg-white px-4 sm:px-6 pt-4 sm:pt-6 pb-2 border-b z-10">
              <h3 className="text-base sm:text-lg font-bold">Offer Details</h3>
            </div>

            {/* Scrollable Content */}
            <div className="px-4 sm:px-6 py-4 overflow-y-auto flex-1">
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">

                {/* LEFT COLUMN */}
                <div className="flex-1 space-y-1 sm:space-y-2 text-gray-700 text-sm sm:text-base">
                  <p><strong>Offer ID:</strong> {selectedViewOffer.id}</p>
                  <p><strong>Product Name:</strong> {selectedViewOffer.product_name}</p>
                  <p><strong>Category:</strong> {selectedViewOffer.category}</p>
                  <p><strong>Region:</strong> {selectedViewOffer.region}</p>
                  <p><strong>Quantity:</strong> {selectedViewOffer.quantity}</p>
                  <p><strong>Price:</strong> {selectedViewOffer.price ?? "N/A"}</p>
                  <p><strong>Grade:</strong> {selectedViewOffer.grade}</p>
                  <p><strong>Process:</strong> {selectedViewOffer.process}</p>
                  <p><strong>Transaction:</strong> {selectedViewOffer.transaction}</p>
                  <p><strong>Description:</strong> {selectedViewOffer.description}</p>
                  <p><strong>Poster:</strong> {selectedViewOffer.poster}</p>
                  <p><strong>Date:</strong> {new Date(selectedViewOffer.createdAt).toLocaleString()}</p>
                </div>

                {/* RIGHT COLUMN (IMAGE) */}
                {selectedViewOffer.image_filelink || selectedViewOffer.picture_link || selectedViewOffer.product?.picture_link ? (
                  <div className="flex-1 flex items-center justify-center">
                    <img
                      src={selectedViewOffer.image_filelink || selectedViewOffer.picture_link || selectedViewOffer.product?.picture_link}
                      alt={selectedViewOffer.product_name}
                      className="max-w-full max-h-40 sm:max-h-64 object-cover rounded"
                    />
                  </div>
                ) : null}

              </div>
            </div>

            {/* Sticky Footer Button */}
            <div className="sticky bottom-0 bg-white border-t px-4 sm:px-6 py-3 sm:py-4 flex justify-end">
              <button
                onClick={() => setSelectedViewOffer(null)}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 text-sm sm:text-base"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showBulkConfirm && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setShowBulkConfirm(false)} // click outside closes
        >
          <div
            className="bg-white rounded shadow-lg w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()} // prevent outside click from closing
          >
            {/* Sticky Header */}
            <div className="sticky top-0 bg-white px-4 sm:px-6 pt-4 sm:pt-6 pb-2 border-b z-10">
              <h3 className="text-base sm:text-lg font-bold">
                Confirm Bulk Repost
              </h3>
            </div>

            {/* Scrollable Content */}
            <div className="px-4 sm:px-6 py-4 overflow-y-auto flex-1">
              <p className="text-gray-700 mb-3 text-sm sm:text-base">
                You are about to repost the following offers:
              </p>

              {/* List selected offers */}
              <div className="max-h-40 overflow-y-auto border p-3 rounded text-sm sm:text-base">
                {selectedBulkOffers.map((id) => (
                  <div key={id} className="text-gray-800">
                    Offer ID: <span className="font-semibold">{id}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Sticky Footer Buttons */}
            <div className="sticky bottom-0 bg-white border-t px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
              <button
                onClick={() => setShowBulkConfirm(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 text-sm sm:text-base order-2 sm:order-1"
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  setShowBulkConfirm(false);
                  handleBulkRepost();
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm sm:text-base order-1 sm:order-2"
              >
                Repost Selected Offers
              </button>
            </div>
          </div>
        </div>
      )}
      {selectedEditOffer && (
        <EditOfferPopup
          offer={selectedEditOffer}
          onClose={() => setSelectedEditOffer(null)}
          onSaved={(message) => {
            setSelectedEditOffer(null);
            loadOffers();
            setToast({ message: message || "Offer updated successfully!", isError: false });
          }}
          onError={(message) => {
            setToast({ message: message || "Failed to update offer.", isError: true });
          }}
        />
)}

    </div>
  );
}

const categoryMapping = {
    CoffeeAndMainCommodities: "Coffee / ቡና",
    FruitCrops: "Fruit Crops / ፍራፍሬች",
    BuildingMaterials: "Building Materials / የግንባታ እቃዎች",
    GrainsAndCereals: "Grains and Cereals / የእህል ሰብሎች",
    PulsesLegumes: "Pulses & Legumes / ጥራጥሬዎች ",
    OilSeeds: "Oil Seeds / የቅባት እህሎች",
    RootCrops: "Root Crops / የስራስር ሰብሎች",
    Vegetables: "Vegetables  / አትክልቶች",
    SpicesHerbs: "Spice & Herbs / ቅመማ ቅመሞቾ",
  };  

  const reverseCategoryMapping = {
  "Coffee / ቡና": "CoffeeAndMainCommodities",
  "Fruit Crops / ፍራፍሬች": "FruitCrops",
  "Building Materials / የግንባታ እቃዎች": "BuildingMaterials",
  "Grains and Cereals / የእህል ሰብሎች": "GrainsAndCereals",
  "Pulses & Legumes / ጥራጥሬዎች ": "PulsesLegumes",
  "Oil Seeds / የቅባት እህሎች": "OilSeeds",
  "Root Crops / የስራስር ሰብሎች": "RootCrops",
  "Vegetables  / አትክልቶች": "Vegetables",
  "Spice & Herbs / ቅመማ ቅመሞቾ": "SpicesHerbs",
};

function EditOfferPopup({ offer, onClose, onSaved, onError }) {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [properties, setProperties] = useState([]);
  const [propertyValues, setPropertyValues] = useState({});
  const [measurementOptions, setMeasurementOptions] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isReposting, setIsReposting] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);

  const categoryDisplayName = categoryMapping[offer.category] || offer.category;
  const originalProductId = offer.productId || offer.product_id;
  const categoryChangedByUser = useRef(false);

  const [form, setForm] = useState({
    offer_id: offer.id,
    offer_type: offer.offer_type || "sell",
    category: categoryDisplayName,
    productId: originalProductId,
    product_name: offer.product_name || "",
    description: offer.description,
    quantity: offer.quantity,
    measurement: offer.measurement,
    price: offer.price,
    currency: offer.currency || "Birr",
  });

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleProductChange = (productId) => {
    const selected = products.find((p) => String(p.id) === String(productId));
    setForm((prev) => ({
      ...prev,
      productId,
      product_name: selected?.name || "",
      measurement: "",
    }));
  };

  const buildUpdatePayload = () => {
    const selectedProduct = products.find(
      (p) => String(p.id) === String(form.productId)
    );

    const payload = {
      offerId: offer.id,
      productId: form.productId,
      product_name: form.product_name || selectedProduct?.name || offer.product_name,
      categoryName: form.category,
      category: form.category,
      description: form.description,
      quantity: form.quantity,
      measurement: form.measurement,
      price: form.price,
      currency: form.currency,
      offer_type: form.offer_type,
    };

    properties.forEach((prop) => {
      const key = prop.name.toLowerCase();
      payload[key] = form[key] || "";
    });

    return payload;
  };

  const performUpdate = async () => {
    await updateOffer(form.category, buildUpdatePayload());
    setShowConfirm(false);
  };

  // ----------------------------------
  // LOAD CATEGORIES
  // ----------------------------------
  useEffect(() => {
    getCategories().then((data) => setCategories(data || []));
  }, []);

  // ----------------------------------
  // LOAD PRODUCTS ON CATEGORY CHANGE
  // ----------------------------------
  useEffect(() => {
    if (!form.category) return;

    getAllProductsByCategory(form.category).then((data) => {
      setProducts(data || []);

      if (categoryChangedByUser.current) {
        categoryChangedByUser.current = false;
        setForm((prev) => ({
          ...prev,
          productId: "",
          product_name: "",
          measurement: "",
        }));
        return;
      }

      setForm((prev) => {
        const alreadyValid =
          prev.productId &&
          data.some((p) => String(p.id) === String(prev.productId));

        if (alreadyValid) return prev;

        const exact = data.find((p) => p.name === offer.product_name);
        if (exact) {
          return { ...prev, productId: exact.id, product_name: exact.name };
        }
        return prev;
      });
    });
  }, [form.category]);

  // ----------------------------------
  // LOAD PROPERTIES + VALUES + UNITS
  // ----------------------------------
  useEffect(() => {
    if (!form.productId || !form.category) return;

    getPropertiesByProduct(form.productId, form.category).then((props) => {
      setProperties(props);

      const isOriginalProduct =
        String(form.productId) === String(originalProductId);

      setForm((prev) => {
        const updates = {};
        props.forEach((prop) => {
          const key = prop.name.toLowerCase();
          updates[key] = isOriginalProduct ? offer[key] || "" : "";
        });
        return { ...prev, ...updates };
      });

      props.forEach((prop) => {
        getPropertyValues(form.productId, prop.id, form.category).then((vals) => {
          setPropertyValues((prev) => ({
            ...prev,
            [prop.id]: vals,
          }));
        });
      });
    });

    getProductById(form.productId, form.category).then((product) => {
      try {
        if (product.measurement) {
          setMeasurementOptions(JSON.parse(product.measurement) || []);
        }
      } catch {}
    });
  }, [form.productId, form.category]);

  // ----------------------------------
  // SAVE ACTION => Show Confirm Modal
  // ----------------------------------
  const handleSaveClick = () => {
    setShowConfirm(true);
  };

  // ----------------------------------
  // UPDATE ONLY
  // ----------------------------------
  const updateOnly = async () => {
    setIsUpdating(true);
    try {
      await performUpdate();
      onSaved();
    } catch (error) {
      console.error("Error updating offer:", error);
      onError?.("Failed to update offer.");
      throw error;
    } finally {
      setIsUpdating(false);
    }
  };

  // ----------------------------------
  // UPDATE + REPOST
  // ----------------------------------
  const updateAndRepost = async () => {
    setIsReposting(true);
    try {
      const categoryKey =
        reverseCategoryMapping[form.category] ||
        reverseCategoryMapping[offer.category] ||
        offer.category;

      await performUpdate();

      await repostOffer(categoryKey, offer.id);
      await updateRepostOffer(categoryKey, offer.id);

      onSaved("Offer updated and reposted successfully!");
    } catch (error) {
      console.error("Error updating and reposting offer:", error);
      onError?.("Failed to update and repost offer.");
    } finally {
      setIsReposting(false);
    }
  };
const handleWheel = (e) => e.target.blur(); // prevents wheel from changing value
  const handleKeyDown = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };


  return (
    <>
      {/* ---------------------- MAIN EDIT POPUP ------------------------- */}
     <div 
       className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 p-4"
       onClick={onClose}
     >
       <div 
         className="bg-white rounded-lg shadow-lg w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl max-h-[90vh] flex flex-col"
         onClick={(e) => e.stopPropagation()}
       >
          {/* Sticky Header */}
          <div className="sticky top-0 bg-white px-4 sm:px-6 pt-4 sm:pt-6 pb-2 border-b z-10">
            <h2 className="text-base sm:text-lg font-bold">Edit Offer</h2>
          </div>
          
          {/* Scrollable Content */}
        <div className="px-4 sm:px-6 py-4 overflow-y-auto flex-1">
          <h3 className="font-semibold">Offer ID: <span className="font-normal">{form.offer_id}</span></h3>
          <br />
          <label className="font-semibold">Offer Type</label>
            <select
              className="border p-2 rounded w-full mb-4"
              value={form.offer_type}
              onChange={(e) => updateField("offer_type", e.target.value)}
            >
              <option value="sell">Sell</option>
              <option value="buy">Buy</option>
            </select> 
          {/* Category */}
          <label className="font-semibold">Category</label>
          <select
            className="border p-2 rounded w-full mb-4"
            value={form.category}
            onChange={(e) => {
              categoryChangedByUser.current = true;
              updateField("category", e.target.value);
            }}
          >
            {categories.map((c) => (
              <option key={c.name} value={c.name}>{c.name}</option>
            ))}
          </select>

          {/* Product */}
          <label className="font-semibold">Product</label>
          <select
            className="border p-2 rounded w-full mb-4"
            value={form.productId || ""}
            onChange={(e) => handleProductChange(e.target.value)}
          >
            <option value="">Select Product</option>
            {products.map((p) => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>

          {/* Properties */}
          {properties.length > 0 && (
            <div className="border p-4 rounded mb-4">
              <h3 className="font-semibold mb-2">Commodity Properties</h3>

              {properties.map((prop) => {
                const key = prop.name.toLowerCase();
                return (
                  <div key={prop.id} className="mb-3">
                    <label>{prop.name}</label>
                    <select
                      className="border p-2 rounded w-full"
                      value={form[key] || ""}
                      onChange={(e) => updateField(key, e.target.value)}
                    >
                      <option value="">Select {prop.name}</option>
                      {(propertyValues[prop.id] || []).map((pv) => (
                        <option key={pv.value} value={pv.value}>{pv.value}</option>
                      ))}
                    </select>
                  </div>
                );
              })}
            </div>
          )}

          {/* Quantity */}
          <label>Quantity</label>
          <input
            type="number"
            onWheel={handleWheel}
            onKeyDown={handleKeyDown}
            className="border p-2 rounded w-full mb-4 no-spinner"
            value={form.quantity}
            onChange={(e) => updateField("quantity", e.target.value)}
          />

          {/* Measurement */}
          <label>Unit</label>
          <select
            className="border p-2 rounded w-full mb-4"
            value={form.measurement}
            onChange={(e) => updateField("measurement", e.target.value)}
          >
            {measurementOptions.map((u, idx) => (
              <option key={idx} value={u}>{u}</option>
            ))}
          </select>

          {/* Price */}
          <label>Price</label>
          <input
            type="number"
            onWheel={handleWheel}
            onKeyDown={handleKeyDown}
            className="border p-2 rounded w-full mb-4 no-spinner"
            value={form.price}
            onChange={(e) => updateField("price", e.target.value)}
          />

          {/* Description */}
          <label>Description</label>
          <textarea
            className="border p-2 rounded w-full"
            value={form.description}
            onChange={(e) => updateField("description", e.target.value)}
          />
        </div>
        
        {/* Sticky Footer Buttons */}
        <div className="sticky bottom-0 bg-white border-t px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
          <button className="bg-gray-300 px-4 py-2 rounded text-sm sm:text-base order-2 sm:order-1" onClick={onClose}>
            Cancel Edit
          </button>
          <button className="bg-blue-600 text-white px-4 py-2 rounded text-sm sm:text-base order-1 sm:order-2" onClick={handleSaveClick}>
            Save Changes
          </button>
        </div>
      </div>
     </div>

      {/* ---------------------- CONFIRMATION POPUP ------------------------- */}
      {showConfirm && (
        <div 
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-[60] p-4"
          onClick={() => setShowConfirm(false)}
        >
          <div 
            className="bg-white rounded-lg w-full max-w-md sm:max-w-lg md:max-w-xl max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >

            {/* Sticky Header */}
            <div className="sticky top-0 bg-white px-4 sm:px-6 pt-4 sm:pt-6 pb-2 border-b z-10">
              <h3 className="text-base sm:text-lg font-bold text-center">
                Confirm Update
              </h3>
            </div>

            {/* Scrollable Content */}
            <div className="px-4 sm:px-6 py-4 overflow-y-auto flex-1">
              <p className="mb-3 text-gray-700 text-center text-sm sm:text-base">
                Are you sure you want to apply the following changes?
              </p>

              <div className="border p-3 sm:p-4 rounded text-gray-800 space-y-2 text-sm sm:text-base">
                <p><strong>Offer Type:</strong> {form.offer_type.toUpperCase()}</p>
                <p><strong>Category:</strong> {form.category}</p>
                <p><strong>Product:</strong> {form.product_name || products.find((p) => String(p.id) === String(form.productId))?.name}</p>
                <p><strong>Quantity:</strong> {form.quantity}</p>
                <p><strong>Unit:</strong> {form.measurement}</p>
                <p><strong>Price:</strong> {form.price} {form.currency}</p>
                <p><strong>Description:</strong> {form.description}</p>
              </div>
            </div>

            {/* Sticky Footer Buttons */}
            <div className="sticky bottom-0 bg-white border-t px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row gap-2 sm:gap-3 justify-center">

              {/* CANCEL */}
              <button
                className="bg-gray-400 px-3 py-2 rounded text-white text-xs sm:text-sm"
                disabled={isUpdating || isReposting}
                onClick={() => setShowConfirm(false)}
              >
                No, Go Back
              </button>

              {/* UPDATE ONLY */}
              <button
                className="bg-blue-500 px-3 py-2 rounded text-white text-xs sm:text-sm flex items-center justify-center gap-2"
                disabled={isUpdating || isReposting}
                onClick={updateOnly}
              >
                {isUpdating ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : null}
                {isUpdating ? "Updating..." : "Yes, Update Only"}
              </button>

              {/* UPDATE + REPOST */}
              <button
                className="bg-green-600 px-3 py-2 rounded text-white text-xs sm:text-sm flex items-center justify-center gap-2"
                disabled={isUpdating || isReposting}
                onClick={updateAndRepost}
              >
                {isReposting ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : null}
                {isReposting ? "Reposting..." : "Yes, Update & Repost"}
              </button>

              {/* CANCEL ALL */}
              <button
                className="bg-red-600 px-3 py-2 rounded text-white text-xs sm:text-sm"
                disabled={isUpdating || isReposting}
                onClick={onClose}
              >
                Cancel All Changes
              </button>

            </div>


          </div>
        </div>
      )}
    </>
  );
}


export default ListOffer;
